import React from 'react';
import { RootState, useDispatch, useSelector } from '../../../redux/store';
import { useTranslation } from 'react-i18next';

const MillSheetCount = (): React.ReactElement => {
  const { t } = useTranslation();
  const { searchResults } = useSelector((state: RootState) => state.millSheetSearch);

  // SIDE EFFECT
  // ================================================================================

  // 確認用
  // useEffect(() => {
  // }, []);

  // EVENT HANDLER
  // ================================================================================

  // VIEW
  // ================================================================================

  return (
    <p className="mb-1">
      {t('millSheet.all')} {searchResults.length} {t('millSheet.items')}
    </p>
  );
};

export default MillSheetCount;
